import React from 'react';
import PropTypes, { any } from 'prop-types';
import Filter, { FilterModal, FilterSection } from './Filter';
import DropdownFilter from './FilterComponents/CoreComponents/DropdownFilter';

import styles from '../search.scss';

const CollegesMoreMobileFilter = (props) => {
    const { filters, filterInputs, handleFilterClick, filterModal, closeModals, handleFilterSubmit, clearFilters, searchTypes, handleFilterUpdate, mobileOnly, desktopOnly, 'data-testid': dataTestId } = props;

    const divisions = searchTypes?.divisions ? searchTypes.divisions : [];
    const conferences = searchTypes?.conferences ? searchTypes.conferences : [];
    const filterName = 'collegesMore';

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={filterName}
                handleFilterClick={() => handleFilterClick(filterName)}
                isActive={(filters && (filters.division || filters.conference || filters.utrFitRating)) || filterModal === filterName}
                mobileOnly={true}
                data-testid={dataTestId}
            >
                More...
            </Filter>
            {filterModal === filterName && (
                <FilterModal
                    title={'More...'}
                    onCloseClick={closeModals}
                    clearFilters={() => clearFilters(filterName, true)}
                    handleFilterSubmit={handleFilterSubmit}
                    mobileOnly={mobileOnly}
                    desktopOnly={desktopOnly}
                    data-testid={dataTestId}
                >
                    <FilterSection>
                            <React.Fragment>
                                <div className={styles.searchFilterModalTitle}>Divisions and Conferences</div>
                                <DropdownFilter
                                    options={divisions}
                                    selected={filterInputs.division}
                                    placeholder={'Any Division'}
                                    onChange={(division) => {
                                        handleFilterUpdate({ division });
                                    }}
                                    data-testid={dataTestId && `${dataTestId}.division-dropdown`}
                                />
                                <div className={`mt16`}>
                                    <DropdownFilter
                                        options={conferences}
                                        selected={filterInputs.conference}
                                        placeholder={'Any Conference'}
                                        onChange={(conference) => {
                                            handleFilterUpdate({ conference });
                                        }}
                                        data-testid={dataTestId && `${dataTestId}.conference-dropdown`}
                                    />
                                </div>
                            </React.Fragment>
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

CollegesMoreMobileFilter.propTypes = {
    filters: PropTypes.objectOf(any),
    filterInputs: PropTypes.objectOf(any),
    handleFilterClick: PropTypes.func,
    filterModal: PropTypes.string,
    closeModals: PropTypes.func,
    handleFilterSubmit: PropTypes.func,
    clearFilters: PropTypes.func,
    searchTypes: PropTypes.objectOf(any),
    handleFilterUpdate: PropTypes.func,
    mobileOnly: PropTypes.bool,
    desktopOnly: PropTypes.bool,
    'data-testid': PropTypes.string,
};

CollegesMoreMobileFilter.defaultProps = {
    filters: {},
    filterInputs: {},
    handleFilterClick: () => { },
    filterModal: '',
    closeModals: () => { },
    handleFilterSubmit: () => { },
    clearFilters: () => { },
    searchTypes: {},
    handleFilterUpdate: () => { },
    mobileOnly: false,
    desktopOnly: false,
    'data-testid': undefined,
};

export default CollegesMoreMobileFilter;
